module.exports = __webpack_public_path__ + "img/bzd.28d6b383.png";